module.exports = __webpack_public_path__ + "img/unicode_codepoint_to_char.0f0c870d.png";